module.exports = __webpack_public_path__ + "7ef45ebbe7704e78e8c71532778585b7.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-64.png
// module id = 138
// module chunks = 0